module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/tabination/animation-pill/animation-pill.component.scss
// module id = ./src/app/features/tabination/animation-pill/animation-pill.component.scss
// module chunks = main